"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Link = props => {
  const {
    attributes,
    children,
    node
  } = props;
  const {
    data
  } = node;
  const href = data.get('href');
  return /*#__PURE__*/_react.default.createElement("a", _extends({}, attributes, {
    href: href
  }), children);
};
var _default = exports.default = Link;
module.exports = exports.default;